export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/48d0057cf54c678c61fc778c0aeda84f.svg";